/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_Load_Title_HintInputs */

const en_audio_description_export_preset_load_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Load_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load a saved preset`)
};

const fr_audio_description_export_preset_load_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Load_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger un préréglage enregistré`)
};

const de_audio_description_export_preset_load_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Load_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine gespeicherte Voreinstellung laden`)
};

const it_audio_description_export_preset_load_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Load_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica un preset salvato`)
};

const ru_audio_description_export_preset_load_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Load_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузите сохраненный пресет`)
};

const es_audio_description_export_preset_load_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Load_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar un ajuste preestablecido guardado`)
};

const zh_cn2_audio_description_export_preset_load_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Load_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载已保存的预设`)
};

const ja_audio_description_export_preset_load_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Load_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存したプリセットを読み込む`)
};

const hi_audio_description_export_preset_load_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Load_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक सहेजा हुआ प्रीसेट लोड करें`)
};

const pt_pt2_audio_description_export_preset_load_title_hint = /** @type {(inputs: Audio_Description_Export_Preset_Load_Title_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar uma predefinição salva`)
};

/**
* | output |
* | --- |
* | "Load a saved preset" |
*
* @param {Audio_Description_Export_Preset_Load_Title_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_load_title_hint = /** @type {((inputs?: Audio_Description_Export_Preset_Load_Title_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_Load_Title_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_preset_load_title_hint(inputs)
	if (locale === "de") return de_audio_description_export_preset_load_title_hint(inputs)
	if (locale === "it") return it_audio_description_export_preset_load_title_hint(inputs)
	if (locale === "ru") return ru_audio_description_export_preset_load_title_hint(inputs)
	if (locale === "es") return es_audio_description_export_preset_load_title_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_preset_load_title_hint(inputs)
	if (locale === "ja") return ja_audio_description_export_preset_load_title_hint(inputs)
	if (locale === "hi") return hi_audio_description_export_preset_load_title_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_preset_load_title_hint(inputs)
	return en_audio_description_export_preset_load_title_hint(inputs)
});